"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const utils_1 = require("utils");
const reducer_1 = require("../reducer");
const AuthorizationTooltip_1 = __importDefault(require("./AuthorizationTooltip"));
function AuthorizedLink({ children, currentPermissions, requiredPermission, selectionCriteria = 'ALL', forceDisabled = false, to, ...rest }) {
    return forceDisabled ||
        (0, utils_1.operationNotPermitted)(currentPermissions, requiredPermission, selectionCriteria) ? ((0, jsx_runtime_1.jsx)(DisabledLink, { children: children })) : ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { ...rest, to: to, children: children }));
}
function mapStateToProps(state) {
    return {
        currentPermissions: reducer_1.selectors.currentPermissions(state),
    };
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(AuthorizedLink);
const DisabledLink = (0, react_1.forwardRef)(function DisabledLink({ children, ...rest }, ref) {
    return ((0, jsx_runtime_1.jsx)(AuthorizationTooltip_1.default, { displayed: true, children: (0, jsx_runtime_1.jsx)("span", { className: "disabled-link", ref: ref, ...rest, children: children }) }));
});
DisabledLink.displayName = 'DisabledLink';
